import React from "react";

const map = {
  voting: { cls: "lp-badge-voting", label: "Launching" },
  pre_order: { cls: "lp-badge-preorder", label: "Pre-order" },
  launched: { cls: "lp-badge-fulfilled", label: "On sale" },
  fulfilled: { cls: "lp-badge-fulfilled", label: "Fulfilled" },
  closed: { cls: "lp-badge-closed", label: "Closed" },
  pending: { cls: "lp-badge-pending", label: "Pending" },
};

export default function StatusBadge({ status, testId }) {
  const v = map[status] || map.voting;
  return (
    <span className={`lp-badge ${v.cls}`} data-testid={testId || `status-${status}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {v.label}
    </span>
  );
}
